<script lang="ts">
  export let center = false
</script>

<p class:center class={$$props.class}>
  <slot />
</p>

<style lang="scss">
  p {
    font-family: "BeausiteClassicWeb-Regular";
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.75rem;
    color: #474f57;
    margin: 0;

    &.center {
      text-align: center;
    }
  }
</style>
